import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { fetchUserProfileData } from '../../api/user-profile-api';

const initialState = {
  data: {},
  loading: true,
};

export const fetchUserProfile = createAsyncThunk('user/profile', async (id) => {
  try {
    const res = await fetchUserProfileData(id);
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

const UserProfileSlice = createSlice({
  name: 'userprofile',
  initialState,
  reducers: {
    setUserData: (state, { payload }) => {
      state.data = payload || {};
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchUserProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUserProfile.fulfilled, (state, action) => {
        state.data = action?.payload || {};
        state.loading = false;
      })
      .addCase(fetchUserProfile.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setUserData } = UserProfileSlice.actions;
export default UserProfileSlice.reducer;
